import { render, staticRenderFns } from "./userstoreitemsTab.vue?vue&type=template&id=efb75888&"
import script from "./userstoreitemsTab.vue?vue&type=script&lang=js&"
export * from "./userstoreitemsTab.vue?vue&type=script&lang=js&"
import style0 from "./userstoreitemsTab.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports